import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.id,
      id: item.id,
      uuid: item.regular_user.uuid,
      checkbox: { id: item.regular_user.uuid, selected: item.selected },
      user: item.regular_user,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getUnmaskingConnections({ payload: { signal, curr_page, searchQ } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.unmasking.connections.search,
      params: { page: curr_page, q: searchQ },
      data: { q: searchQ },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next,
      curr_page
    };

    yield put(actions.getUnmaskingConnectionsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getUnmaskingConnectionsFailed,
      endpoint: api.unmasking.connections.search.url
    });
  }
}

export const getUnmaskingConnectionsSaga = takeEvery(types.GET_UNMASKING_CONNECTIONS_REQUEST, getUnmaskingConnections);